
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/data-management-and-insight",
      function () {
        return require("private-next-pages/solutions/data-management-and-insight/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/data-management-and-insight"])
      });
    }
  